export default [
  {
    name: 'Blocks.List',
    path: '',
    component: () => import('./components/List')
  }
]
